export const kk = {
  'hx': {
    'order-receipt': {
      'ofd': 'ФДО',
      'checkSite': 'түбіртекті тексеру үшін келесі сайтқа өтіңіз',
      'address': 'Жеткізу мекенжайы',
      'cancellation': 'Бас тарту себебі',
      'cashier': 'Кассир',
      'check': 'Түбіртек',
      'checkHidden': 'Түбіртек басылды',
      'client': 'Тұтынушы',
      'footer': '© Happy Tech App',
      'ng': {
        'courier': 'Жеткізуші'
      },
      'noCheck': 'ТҮБІРТЕКСІЗ',
      'note': 'Ескертпе',
      'paid': 'Сатып алғаныңыз үшін рахмет!',
      'paidMethod': 'Төлем әдісі',
      'printCheck': 'Түбіртек басу',
      'printedCheck': 'Түбіртек басылды',
      'return': 'Қайтару',
      'series': 'ҚҚС Сериясы',
      'table': {
        'body': {
          'discount': 'Жеңілдіктер',
          'text': 'соның ішінде ҚҚС: 12%',
          'total': 'Жалпы',
          'totalAll': 'БАРЛЫҒЫ'
        },
        'head': {
          'name': 'Тауар атауы',
          'num': 'Саны',
          'sum': 'Сома',
          'weight': 'Салмағы'
        }
      },

      'thanks': 'Сатып алғаныңыз үшін рахмет!',
      'timeDelivery': 'Жеткізу уақыты',
      'timePickup': 'Өзі алып кету уақыты',
      'user': 'Алушы'
    },
    'product-list': {
      'hiddenCategories': 'Жасырылған санаттар',
      'hideCategory': 'Санатты жасыру',
      'showCategory': 'Санатты көрсету'
    },
    'receipt': {
      'fiscalCheck': 'Фискалды түбіртек',
      'fiscalization': 'Фискалдандыру',
      'offlineMode': 'Түбіртек автономды режимде құрылды',
      'wkCashboxFactoryNumber': 'МЗН',
      'wkCashboxIdentificationNumber': 'КИН ФДО',
      'wkCashboxRegistrationNumber': 'МТН',
      'wkFiscalDate': 'Күні',
      'wkFiscalNumber': 'ФБ'
    }
  }
};
